/**
 * Invoice
 */

class Invoice {

    constructor(document) {
        const data = document.data()

        this.uid = document.id

        this.createdAt = data.createdAt ? data.createdAt : new Date()
        this.title = data.title;
        this.zipCode = data.zipCode;
        this.address = data.address;
        this.city = data.city;
        this.amount = data.amount;
        this.deliveries = data.deliveries;
        this.invoiceID = data.invoiceID;
        this.status = data.status;
    }

    get data() {
        return {
            uid: this.uid,
            createdAt: this.createdAt,
            title: this.title,
            zipCode: this.zipCode,
            address: this.address,
            city: this.city,
            amount: this.amount,
            deliveries: this.deliveries,
            invoiceID: this.invoiceID,
            status: this.status
        }
    }

    ID() {
        return this.invoiceID
    }

    firebaseStoragePath() {
        return "invoices/Facture-" + this.ID() + ".pdf"
    }

}

export default Invoice;